import { useCaseFileModelContext } from "../../../contexts/useCaseFileModelContext";
import { useGetOrganizationByCaseModel } from "../../../shared/react-query-hooks/useGetOrganizationByCaseModel";

export interface ISelectedFiltersDetails {
    label: string;
    values: string[];
}

export function ZoneGroupDetailsBody() {
    const { caseFileModelId } = useCaseFileModelContext();
    const query = useGetOrganizationByCaseModel(caseFileModelId);

    if (query.isLoading) {
        return <div>Loading...</div>;
    }

    if (query?.data?.length === 0) {
         return <div>No Zones in Group</div>;
    }

    return (
        <div style={{ maxHeight: '650px', overflow: 'auto'}}>
            {query?.data?.map((org) => (
                <div key={org.guid}>
                    <div className="">{org.name}</div>
                </div>
            ))}
        </div>
    );
}
